module.exports = __webpack_public_path__ + "9904421768a7a16b5dbe513b41492bba.svg";